class BookingModel {
  constructor(courseId, players) {
    this.courseId = courseId;
    this.players = players;
    this.manual = true;
  }
}

export { BookingModel };
